import React from 'react';
export const ArrowIcon = ({
  direction = 'left'
}) => (/*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--icon-color)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.25",
  d: pathByDirection[direction]
})));
const pathByDirection = {
  left: 'M15.75 19.5 8.25 12l7.5-7.5',
  top: 'm4.5 15.75 7.5-7.5 7.5 7.5',
  right: 'm8.25 4.5 7.5 7.5-7.5 7.5',
  bottom: 'm19.5 8.25-7.5 7.5-7.5-7.5'
};